import { SectionTabs, type SectionTab } from '../components/SectionTabs';
import { useIsDriversManager } from './hooks/useIsDriversManager';

/** DAAily Drivers sub-nav. Cabinet + your nominations; the Monthly board tab
 *  shows only for Drivers approvers/admins (self-filtered like other tools). */
export function DriversSection() {
  const isManager = useIsDriversManager();
  const tabs: SectionTab[] = [
    { to: '/drivers', label: 'Trophy Cabinet', end: true },
    { to: '/drivers/nominations', label: 'Received', end: true },
    { to: '/drivers/nominations/given', label: 'Given' },
    { to: '/drivers/team', label: 'My team' },
    ...(isManager
      ? [
          { to: '/drivers/board', label: 'Monthly board' },
          { to: '/drivers/summary', label: 'Org summary' },
        ]
      : []),
  ];
  return <SectionTabs title="DAAily Drivers" tabs={tabs} />;
}
